import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Come Usare Itaobuy Spreadsheet: Guida Passo Passo per Principianti',
  url: `${siteUrl}/come-usare-itaobuy-spreadsheet`,
  description: 'Impara a navigare il database, trovare i prodotti migliori e fare acquisti intelligenti con itaobuy spreadsheet.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function ComeUsarePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ TUTORIAL</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Come Usare Itaobuy Spreadsheet: Guida Passo Passo per Principianti
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Impara a navigare il database, trovare i prodotti migliori e fare acquisti intelligenti con <strong className="text-background-50">itaobuy spreadsheet</strong>.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per esplorare tutte le categorie.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Primi Passi con Itaobuy Spreadsheet</h2>
              <p className="mb-4">Iniziare con <strong className="text-foreground-950">itaobuy spreadsheet</strong> è più semplice di quanto pensi. Il primo passo è visitare la <Link to="/" className="text-primary-600 font-medium hover:underline">homepage di itaobuyspread.baby</Link>, dove troverai tutte le categorie organizzate in modo intuitivo. Dal menu a tendina "Categorie", puoi selezionare il tipo di prodotto che ti interessa ed essere reindirizzato direttamente alla pagina corrispondente.</p>
              <p>Una volta scelta la categoria, potrai sfogliare i prodotti, leggere le descrizioni e, soprattutto, controllare le <strong className="text-foreground-950">foto QC</strong> per verificare la qualità prima dell'ordine. Il database è pensato per essere accessibile anche ai principianti, con interfacce chiare e navigazione intuitiva.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Come Trovare i Prodotti Migliori</h2>
              <p className="mb-4">Per trovare i <strong className="text-foreground-950">prodotti migliori su itaobuy</strong>, il consiglio è di utilizzare i filtri per categoria e controllare sempre il rating e le recensioni. Il database è aggiornato settimanalmente, garantendo che tu abbia sempre accesso ai prodotti più recenti e alle migliori offerte disponibili.</p>
              <p>Non dimenticare di consultare anche le altre guide disponibili sul sito, come la <Link to="/itaobuy-e-sicuro" className="text-primary-600 font-medium hover:underline">guida alla sicurezza</Link> e le <Link to="/itaobuy-recensioni" className="text-primary-600 font-medium hover:underline">recensioni degli utenti italiani</Link>.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Consigli per Risparmiare</h2>
              <p className="mb-4">Utilizzare <strong className="text-foreground-950">itaobuy spreadsheet</strong> ti permette di confrontare prezzi e qualità in un unico posto. Per risparmiare, cerca i prodotti con il miglior rapporto qualità-prezzo e approfitta delle offerte stagionali. La community di utenti italiani condivide regolarmente codici sconto e promozioni attive.</p>
              <p>Visita anche la <Link to="/itaobuy-prezzi" className="text-primary-600 font-medium hover:underline">guida ai prezzi e costi</Link> per una panoramica completa su come ottimizzare il tuo budget.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Inizia Ora!</h3>
              <p className="text-sm text-foreground-600 mb-5">Accedi subito al database e inizia a esplorare i prodotti.</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400">Guida all'uso di <strong className="text-foreground-500">itaobuy spreadsheet</strong>. <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}